class BannerController {
    getLinkTarget() {
        return (this.banner.LinkTarget === 'NewWindow') ? '_blank' : undefined;
    }
}

const bannerComponentDefinition = {
    bindings: {
        banner: '<',
    },
    controller: BannerController,
    template: require('./banner.component.html').trim(),
};

module.exports = {
    BannerController,
    bannerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/banners/banner.component.js